export default "__VITE_ASSET__DwI9I65s__"